import React, { useEffect, useReducer } from 'react';

// REDUX
import { getNumberOfSymbolsPerReel } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';
import { IReelStatesState, ReelStatesDefault } from './ReelSets.types';

// STYLES
import { IFixData } from '../../../Fixes.types';
import ReelSetsReel from './ReelSets.reel';
import styles from './ReelSets.scss';

const ReelSets: React.FC<{ fixData: IFixData; fixArrays: number[][] }> = ({ fixData, fixArrays }) => {
    const [state, setState] = useReducer((state: IReelStatesState, newState: {}) => ({ ...state, ...newState }), ReelStatesDefault);

    const numberOfSymbols = useAppSelector(getNumberOfSymbolsPerReel);

    useEffect(() => {
        if (fixArrays.length > 0) {
            setState({
                active: true,
                reelSetsData: fixArrays
            });
        }
    }, [fixArrays]);

    return (
        <>
            {state.active && (
                <div>
                    <div className={styles.reel_sets_reels_list}>
                        {state.reelSetsData.map((e, index) => (
                            <ReelSetsReel key={index} reelSet={e} reelIndex={index} reelStopIndex={fixData[index]} noOfSymbols={numberOfSymbols} />
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default ReelSets;
